import { FraudDomainBean, FraudDomainControllerApi, ItemResponseFraudDomainBeanObject, ListResponseFraudDomainBean } from 'src/api/api'
import { BaseApi, configuration } from '../../../api/BaseApi'

class FraudDomainApi extends BaseApi {
    api: FraudDomainControllerApi

    constructor() {
        super()
        this.api = new FraudDomainControllerApi(configuration, configuration.basePath, this.fetch)
    }

    async list(size: number = 20, page: number = 1, sort, search, blockingReason): Promise<ListResponseFraudDomainBean> {
        return this.call(() => this.api.fraudDomainList(search, blockingReason, { query: { size, page, sort } }))
    }

    async delete(id: number): Promise<void> {
        return this.call(() => this.api.deleteFraudDomain(id))
    }

    async activate(id: any): Promise<void> {
        return this.call(() => this.api.activateFraudDomain(id))
    }
}

const fraudDomainApi = new FraudDomainApi()
export default fraudDomainApi



// WEBPACK FOOTER //
// ./src/component/app/fraudDomain/FraudDomainApi.ts